import React from 'react'
import { RichTextEditor, RichTextRenderer } from 'packages/components/RichText'
import {
  PaperAnswer,
  PaperBlock,
  PaperQuestion,
} from 'packages/sdks-next/growp'
import { Analysis } from '../Analysis'
import { useAnswersManagement } from '../context'
import { getReviewById, getValueById, updateAnswers } from '../utils'
import styled from 'styled-components'
import { TrueOrFalseTag } from '../TrueOrFalseTag'
import { ReadOver } from '../ReadOver'
import { QuizMode } from '../types'
import { getTheme } from '@/utils/theme'
import { AnyType } from 'packages/types'
import { InputWithUpload } from './InputWithUpload'
import { cloneDeep } from '@seiue/util'

export const ShortAnswer: React.FC<{
  mainQuestion: PaperQuestion
  block: PaperBlock
}> = ({ mainQuestion, block }) => {
  const theme = getTheme()
  const { mode, answers, setAnswers, reviews, isReviewed } =
    useAnswersManagement()
  const { value, answer } = getValueById(
    answers as PaperAnswer[],
    mainQuestion.id
  )
  const cloneValue = cloneDeep(value)
  const textValue = value && value?.length > 0 ? value[0] : ''
  const attachList =
    cloneValue && cloneValue?.length > 1 ? cloneValue?.splice(1) : []
  const fileList = attachList.map((a) => JSON.parse(a))
  const onUpdateAnswers = (newValue: string[]) => {
    const newAnswers = updateAnswers(answers, {
      questionId: mainQuestion.id,
      value: newValue,
    })
    setAnswers(newAnswers)
  }
  const { gainScore, result, review } = getReviewById(reviews, mainQuestion.id)
  return (
    <div>
      <InputWithUpload
        disabled={[
          QuizMode.Completed,
          QuizMode.Review,
          QuizMode.Reviewed,
        ].includes(mode)}
        allowUploadImage={true}
        textAreaMode={true}
        textValue={textValue}
        onTextValueChange={(v) => {
          let newValue = [v || '', ...attachList]
          if ((!attachList || !attachList.length) && !v) {
            newValue = []
          }
          onUpdateAnswers(newValue)
        }}
        fileList={fileList}
        onFileListChange={(filelist) => {
          let newValue = [textValue, ...filelist]
          if (!textValue && (!filelist || !filelist.length)) {
            newValue = []
          }
          onUpdateAnswers(newValue)
        }}
      />
      {[QuizMode.Answering, QuizMode.Completed, QuizMode.Preview].includes(
        mode
      ) ? null : (
        <Analysis
          mainQuestion={mainQuestion}
          block={block}
          LeftNode={
            <LeftNodeWrapper>
              {review || !answer?.answerId ? (
                <TrueOrFalseTag
                  score={gainScore}
                  mode={result}
                />
              ) : (
                <div style={{ minWidth: '84px' }} />
              )}
              {isReviewed ||
              mode === QuizMode.Reviewed ||
              !answer?.answerId ? null : (
                <ReadOver
                  score={mainQuestion.score}
                  answer={answer as AnyType}
                  review={review}
                />
              )}
            </LeftNodeWrapper>
          }
        />
      )}
    </div>
  )
}

const LeftNodeWrapper = styled.div`
  height: 32px;
  display: flex;
  align-items: flex-end;
  margin-bottom: 8px;
`
